// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"f49351e6293063c7","170":"bfeddb0949f1554d","364":"569e3909e98490bd","681":"84985bb9acaaaaee","777":"51da5dc73639e28c"}[chunkId] + ".js";
};